<template>
  <div class="student-gains-grid-item-component"
       @click="handleClick"
  >
    <div class="student-gains-grid-item-cover-container">
      <ym-img class="student-gains-grid-item-cover"
              :src="item.cover"
      />
      <ym-icon class="student-gains-grid-item-icon" name="round-play-fill" />
    </div>
    <div class="student-gains-grid-item-title ym-ellipsis-two">{{ item.title }}</div>
    <div class="student-gains-grid-item-summary ym-ellipsis">{{ item.summary }}</div>
  </div>
</template>

<script>
  import { getProductPath, locationHref, projectJump } from '@/utils';

  export default {
    name: 'StudentGainsGridItem',
    props: {
      item: {
        type: Object,
        required: true,
      },
    },
    methods: {
      handleClick() {
        const { item } = this;
        const { target, id, productUrl } = item;
        if (productUrl && productUrl !== '') {
          locationHref(productUrl);
          return;
        }
        const { type } = target;
        const route = getProductPath(type, id);
        projectJump(route);
      },
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  @student-gains-grid-item-width: 320px;
  @student-gains-grid-item-height: 180px;
  .student-gains-grid-item {
    &-component {
      margin: @size-base 0;
      width: @student-gains-grid-item-width;
    }

    &-cover {
      width: 100%;
      height: 100%;

      &-container {
        position: relative;
        border-radius: @border-radius-normal;
        overflow: hidden;
        height: @student-gains-grid-item-height;
        margin-bottom: @size-small;
      }
    }

    &-icon {
      font-size: 40px;
      position: absolute;
      right: @size-extra-small;
      bottom: @size-extra-small;
    }

    &-title {
      font-size: @font-size-medium;
    }

    &-summary {
      margin-top: @size-extra-small;
      font-size: @font-size-small;
      color: @color-text-lighter;
    }
  }
</style>
